import { BankRegistrationModal } from './BankRegistrationModal';
import { useState } from 'react';
import { Upload, X, Check } from 'lucide-react';

export default function BankSelectbox ({ title, options, selected, onChange, onRegisterBank, isoCode3 }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {title}
      </label>
      
      <div className="flex gap-2">
        <select
          value={selected.name}
          onChange={(e) => {
            const selectedBank = options.find(bank => bank.name === e.target.value);
            if (selectedBank) onChange(selectedBank);
          }}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Seleccionar banco</option>
          {options.map((bank, idx) => (
            <option key={idx} value={bank.name}>
              {bank.name} {bank.isCustom ? '(Personalizado)' : ''}
            </option>
          ))}
        </select>
        
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 whitespace-nowrap"
        >
          <Upload className="w-4 h-4" />
          Otro
        </button>
      </div>
      
      {selected.name && (
        <div className="mt-2 flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
          <img
            src={selected.image || '/default-bank-icon.svg'}
            alt={selected.name}
            className="w-8 h-8 object-contain"
            onError={(e) => e.target.src = '/default-bank-icon.svg'}
          />
          <div className="flex-1">
            <p className="text-sm font-medium text-green-800">
              {selected.name}
            </p>
            {selected.isCustom && (
              <p className="text-xs text-green-600">Banco personalizado</p>
            )}
          </div>
          <Check className="w-5 h-5 text-green-600" />
        </div>
      )}

      <BankRegistrationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onRegister={onRegisterBank}
        isoCode3={isoCode3}
      />
    </div>
  );
};